<div class="loading-animation-content my-5">
    <div class="loader">
      @for (item of [0,0,0,0,0]; track $index) {
      <div class="bg-secondary"></div>
      }
    </div>
    
    <span class="text-center" [class.loader-lg]="loaderSize() === 'lg'" [class.loader-sm]="loaderSize() === 'sm'" [class.loader-md]="loaderSize() === 'md'" [class.loader-xs]="loaderSize() === 'xs'">
      {{ message() }}
    </span>
  </div>